<template>
    <modal dialog="modal-lg" class="dark-top" :footer="false"
        :headerStyle="{ 'background-color': currentIntegration.color.main }">
        <div slot="title">
            <h2>Power BI</h2>
        </div>

        <div slot="body">
            <top-area :integration="currentIntegration" />
            <state-label v-if="currentIntegration.integrationStatus != 1" :integration="currentIntegration"
                @close="close()" />

            <div class="px-5 pt-3 pb-4">
                <label>Integration Key</label>
                <input type="text" v-model="currentIntegration.apiKey" class="w-100" disabled>

                <label class="pt-2">Base Endpoint</label>
                <input type="text" class="w-100" disabled v-model="currentIntegration.baseUrl">

                <bottom-area
                    :isIntegrated="false" @close="closeModal()" />
            </div>
        </div>
    </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Modal from '@/tools/modal/Modal'
import topArea from './popupParts/topArea'
import bottomArea from './popupParts/bottomArea'
import stateLabel from './popupParts/stateLabel'

export default {
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'getSelectedIntegration'
        ]),
        currentIntegration() {
            return this.getSelectedIntegration;
        }
    },
    methods: {
        ...mapActions([
            'closeModal'
        ]),
        close() {
            this.closeModal();
        },
    },
    components: {
        topArea,
        bottomArea,
        Modal,
        stateLabel
    }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// powerbiIntegrate.vue?612f8af2